/**
 * Properly formatting number with decimals (for layout, displaying of prices, etc.)
 * @param value
 */
export function formatPrice(value: number | string) {
  const isRound = (n: number) => n.toFixed(9).endsWith("000000000");
  const valueToReturn = typeof value === "string" ? parseFloat(value) : value;
  return valueToReturn ? (isRound(valueToReturn) ? valueToReturn : valueToReturn.toLocaleString("da", { minimumFractionDigits: 2 })) : "0";
}

/**
 * Determines if given element is in viewport
 * @param el
 */
export function isElementInViewport(el: HTMLElement) {
  const rect = el.getBoundingClientRect();

  return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
}
